export default "__VITE_ASSET__Cvo51m4b__"